module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n<span [formGroup]=\"formGroup\">\r\n    <input kendoTextBox #disabledInput\r\n        title=\"{{config.title}}\"\r\n        [id]=\"id\"\r\n        [name]=\"config.name\"\r\n        [formControlName]=\"id\"\r\n    />\r\n</span>"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/disabled-text-box/disabled-text-box.component.html
// module id = ../../../../../src/app/shared/components/disabled-text-box/disabled-text-box.component.html
// module chunks = main